import { RootState } from '../../store/types'

export const convenienceTestQuestionnaireAnswersSelector = (state: RootState) =>
  state.users.convenienceTestQuestionnaireAnswers
